import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateChild
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { IhaleService } from "app/service/ihale.service";
import { CustomHttp } from "app/customhttp";


@Injectable()
export class AdminAccountResultActivateGuard implements CanActivate, CanActivateChild {
  constructor(public http: CustomHttp,
              public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.http.getSuccessResponseSubject()
      .map(
        (e) => {
          if (e) {
              return true;
          } else {
            this.router.navigate(['/yonetim-bilgilerim']);
            return false;
          }
        }
      ).catch(
        () => {
          this.router.navigate(['/yonetim-bilgilerim']);
          return Observable.of(false);
        }
      );

  }

  canActivateChild(route: ActivatedRouteSnapshot,
                   state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/admin/admin-account-result/admin-account-result-activate.guard.ts